import { render, staticRenderFns } from "./UrgentContainerList.vue?vue&type=template&id=06a81058&scoped=true"
import script from "./UrgentContainerList.vue?vue&type=script&lang=js"
export * from "./UrgentContainerList.vue?vue&type=script&lang=js"
import style0 from "./UrgentContainerList.vue?vue&type=style&index=0&id=06a81058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a81058",
  null
  
)

export default component.exports